import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Auglýsingar á miðlum 1819 - {WEBPAGE_TITLE}</title>
            </Head>

            <InfoSection containerStyle={{ padding: 30 }}>
                <ServiceHeader
                    image="/img/thjonusta/auglysingar.png"
                    title="Auglýsa á miðlum 1819"
                />
                <p>
                    <strong>Það er einfalt að auglýsa á miðlum 1819</strong>
                </p>
                <p>
                    1819 býður upp á fjölbreytta auglýsingakosti á sínum miðlum. Þegar að fyrirtæki
                    auglýsa hjá 1819 birtist auglýsingin hvorutveggja á 1819.is og í 1819 appinu.
                    Einungis eru fjórar auglýsingar í hverju plássi þannig að sýnileikinn er mikill.
                    Tugþúsundir einstaklinga nota 1819.is og 1819 appið við upplýsingaleit í hverjum
                    mánuði og birtist auglýsingin því miklum fjölda fólks. Auglýstu þig!
                </p>
                <p style={{ marginTop: "47px", clear: "both" }}>
                    <strong>
                        <u>Auglýsingaborðar á 1819.is og í 1819 appi.</u>
                    </strong>
                </p>
                <p>
                    Eftirfarandi stærðir eru þær sem notast er við fyrir auglýsingaborða á miðlum
                    1819:
                </p>
                <p>
                    <em>1819 vefsíða</em>
                </p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>1018*126 px</li>
                </ul>
                <p>
                    <em>1819 appið.</em>
                </p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>1018*126 px</li>
                </ul>
                <p>
                    <strong>&nbsp;</strong>
                </p>
                <p>
                    <strong>Tegund auglýsinga</strong>
                </p>
                <p>
                    Almennir auglýsingaborðar eru birtir á plássi 1, 2, eða 3 á vefsíðunni
                    www.1819.is og þeim fylgir samhliða birting&nbsp; í 1819 appinu.
                </p>
                <p>
                    Árs leitarorðaauglýsing snýst um að fyrirtæki geta keypt sér leitarorð í heilt
                    ár en á sama tíma getur ekkert annað fyrirtæki valið það orð sem sitt
                    ársleitarorð. Ársleitarorðs auglýsing felur í sér að þegar að notandi á miðlum
                    1819 eða starfsmaður í þjónustuveri okkar slær inn það leitarorð sem fyrirtæki
                    hefur sem sitt ársleitarorð þá birtist auglýsingaborði frá fyrirtækinu efst á
                    heimasíðu eða í appi fyrir ofan allar leitarniðurstöður. Auk þess kemur
                    fyrirtækið alltaf upp sem fyrsta leitarniðurstaða sé ársleitarorð þess slegið
                    inn í leitarvél 1819.&nbsp; Leitarorðið er einnig samkeyrt á GoogleAds.
                </p>
                <p>&nbsp;</p>
                <p>
                    <strong>Auglýsingapláss og verð.</strong>
                </p>
                <table className="table">
                    <tbody>
                        <tr>
                            <td>
                                <p>
                                    <strong>Pláss</strong>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <strong>Stærðir</strong>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <strong>
                                        Verð fyrir viku *<br />
                                    </strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Pláss 1 - Forsíðuborði</p>
                            </td>
                            <td>
                                <p>1018*126 px</p>
                            </td>
                            <td>
                                <p>69.900 kr.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Pláss 2 – Eftir leit</p>
                            </td>
                            <td>
                                <p>1018*126 px</p>
                            </td>
                            <td>
                                <p>59.900 kr.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Pláss 3 – Eftir leit og vörumerkjasíðum**</p>
                            </td>
                            <td>
                                <p>1018*126 px</p>
                            </td>
                            <td>
                                <p>49.900 kr.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Pláss í appi</p>
                            </td>
                            <td>
                                <p>1018*126 px</p>
                            </td>
                            <td>
                                <p>Innifalið í birtingu</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Leitarorða auglýsing</p>
                            </td>
                            <td>
                                <p>1018*126 px</p>
                            </td>
                            <td>
                                <p>260.000 kr.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <small>
                        &nbsp;* Öll verð eru án vsk
                        <br />
                        ** Birtist á öllum einstaklings og vörumerkjasíðum fyrirtækja sem eru ekki í
                        skráningapökkum.
                        <br />
                    </small>
                </p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>Til þess að fá frekari upplýsingar eða aðstoð getur þú haft samband við:</p>
                <ul>
                    <li>Victor Pálmarsson, markaðsstjóra, victor@1819.is</li>
                </ul>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
